import { Component, Input } from "@angular/core";
import { Autoplay, Keyboard, Navigation, Pagination } from "swiper";

export interface Image {
  src: string;
  alt?: string;
  link?: string;
}


// see https://swiperjs.com/element

@Component({
  selector: "app-slider",
  templateUrl: "./slider.component.html",
  styleUrls: ["./slider.component.scss"],
})
export class SliderComponent {
  @Input() sources: Image[] = [];

  swiper_modules = [Autoplay, Keyboard, Pagination, Navigation];
}
